import api from "./client";

export const listSignalMatches = async () => {
  const { data } = await api.get("/signalmatch/");
  return data;
};

export const listSignalMatchesBySite = async (siteId) => {
  const { data } = await api.get(`/signalmatch/site/${siteId}`);
  return data;
};

export const createSignalMatch = async (payload) => {
  const { data } = await api.post("/signalmatch/", payload);
  return data;
};

export const updateSignalMatch = async (id, payload) => {
  const { data } = await api.put(`/signalmatch/${id}`, payload);
  return data;
};

export const deleteSignalMatch = async (id) => {
  const { data } = await api.delete(`/signalmatch/${id}`);
  return data;
};
